module.exports = __webpack_public_path__ + "static/media/LogoGlow.5cbc2861.png";